import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_ADR implements Validator {

    public static id = 'CTRL_ADR';
    private message = 'error.ctr_adr';


    public LOG: LogService = new LogService(CTRL_ADR);


    validate(form: any, map) {


        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_ADR.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];

                const adrPaysNameWithStepId = map.get(ctrl.value.rgCtrls.AdrPays);
                const adrPaysCtrl = form.controls[adrPaysNameWithStepId];
                const adrVilleNameWithStepId = map.get(ctrl.value.rgCtrls.AdrVille);

                var adrCpNameWithStepId;
                var adrNumvoieNameWithStepId;
                var adrTypevoieNameWithStepId;
                var adrNomvoieNameWithStepId;

                if (adrPaysCtrl && adrPaysCtrl.value) {
                    adrCpNameWithStepId = map.get(ctrl.value.rgCtrls.AdrCp_e);
                    adrNumvoieNameWithStepId = map.get(ctrl.value.rgCtrls.AdrVoieNum_e);
                    adrTypevoieNameWithStepId = map.get(ctrl.value.rgCtrls.AdrVoieTypevoie_e);
                    adrNomvoieNameWithStepId = map.get(ctrl.value.rgCtrls.AdrVoieNomvoie_e);                  
                } else {
                    adrCpNameWithStepId = map.get(ctrl.value.rgCtrls.AdrCp);
                    adrNumvoieNameWithStepId = map.get(ctrl.value.rgCtrls.AdrVoieNum);
                    adrTypevoieNameWithStepId = map.get(ctrl.value.rgCtrls.AdrVoieTypevoie);
                    adrNomvoieNameWithStepId = map.get(ctrl.value.rgCtrls.AdrVoieNomvoie);
                }

                const adrCpCtrl = form.controls[adrCpNameWithStepId];
                const adrVilleCtrl = form.controls[adrVilleNameWithStepId];
                const adrVoieNumCtrl = form.controls[adrNumvoieNameWithStepId];
                const adrVoieTypevoieCtrl = form.controls[adrTypevoieNameWithStepId];
                const adrVoieNomvoieCtrl = form.controls[adrNomvoieNameWithStepId];

                var filledInputs = 0;

                if (adrCpCtrl && adrCpCtrl.value) filledInputs++;
                if (adrVilleCtrl && adrVilleCtrl.value) filledInputs++;
                if (adrVoieNumCtrl && adrVoieNumCtrl.value) filledInputs++;
                if (adrVoieTypevoieCtrl && adrVoieTypevoieCtrl.value) filledInputs++;
                if (adrVoieNomvoieCtrl && adrVoieNomvoieCtrl.value) filledInputs++;



                if (filledInputs > 0 && filledInputs < 5) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };

                }
            }
        }
    }
}